import React, { memo, useContext } from 'react'

import { Icon, Typography, Grid } from '..'
import { util } from '../../../util'

import { LanguageContext } from '../../../context/LanguageContext'

const DeviceStatusInfo = ({ status, name, showName, className }) => {
    const { rtl, strings } = useContext(LanguageContext)

    return (
        <Grid.Row className={`flex-row ${className}`}>
            <Icon
                margin={rtl ? 'ml-2' : 'mr-2'}
                size={'xs'}
                color={status ? 'color-check' : 'danger'}
                renderIcon={status ? util.CheckCircleIcon : util.CancelIcon}
            />
            <Typography
                text={
                    showName
                        ? name
                        : status
                          ? strings.OPS_TOOLS_STORES_ON_LABEL
                          : strings.OPS_TOOLS_STORES_OFF_LABEL
                }
                size={'rg'}
            />
        </Grid.Row>
    )
}

export default memo(DeviceStatusInfo)
